module.exports = __webpack_public_path__ + "static/media/RLC_4032a.24d7b076.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/roraima/RLC_4032a.JPG
// module id = 89
// module chunks = 0